import React from 'react';
import Icon from './Icon';

const ICONS = { error: 'error', success: 'check_circle', info: 'info', warning: 'warning' };

// An inline message in the app's colours: <Alert severity="error">…</Alert>
const Alert = ({ severity = 'info', onClose, action, children, className = '' }) => (
    <div className={`ls-alert is-${severity} ${className}`} role={severity === 'error' ? 'alert' : 'status'}>
        <Icon name={ICONS[severity] || 'info'} />
        <div className="ls-alert-body">{children}</div>
        {action}
        {onClose && (
            <button type="button" className="ls-btn ls-btn-icon" style={{ width: 26, height: 26, marginTop: -3, color: 'inherit' }} onClick={onClose} aria-label="Dismiss">
                <Icon name="close" size={18} />
            </button>
        )}
    </div>
);

export default Alert;
